/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.ClientMerge {

  import PhoneTypeEnum = Meevo.Model.PhoneTypeEnum;

  export class ClientMergeContext {

    public readonly securityKeys = Meevo.Components.Common.SecurityKeys;
    public readonly securityParts = Meevo.Components.Common.SecurityParts;
    public canViewBirthdayInfo: boolean = false;
    itemsArrayCtrl: any;
    selectAllBox: boolean;
    mode: Meevo.Model.MaintenanceFormState;
    private backup: any;
    public criteria: any;
    public isFilterHidden: boolean = false;
    private _phoneTypeEnum = {
        [PhoneTypeEnum.Work]: 'HEADER_WORKPHONE',
        [PhoneTypeEnum.Mobile]: 'HEADER_MOBILEPHONE',
        [PhoneTypeEnum.Home]: 'HEADER_HOMEPHONE'
    };

    constructor(
      protected appSettings: Meevo.Components.Common.IAppSettings,
      protected dataService: Meevo.Components.BaseClasses.IDataService,
      protected modalService: Meevo.Components.Modal.IModalService,
      protected trackingService: Meevo.Components.Tracking.ITrackingService,
      protected securityService: Meevo.Components.Common.ISecurityService,
      protected identityService: Meevo.Components.Common.IIdentityService,
      protected $rootScope: angular.IRootScopeService) {
      this.getDefaultCriteria();
      this.mode = Meevo.Model.MaintenanceFormState.Readonly;

      // required to display pager controls
      if (device.mobile()) {
          this.isFilterHidden = true;
      }
    }

    getDefaultCriteria() {
      this.criteria = {
        filter: '',
        showExcludeFromMerge: false,
        includeInactive: 0
      };
      return this.criteria;
    }

    applyFilter(criteria: any, applyFilter: Function): void {
        applyFilter();
        this.usageTrackingLog(Meevo.Model.NounEnum.IntelliMergePage, Model.VerbEnum.ApplyButtonClicked, null);
    }

    clearField(applyFilter: Function, $event?) {
      if ($event) {
        $event.stopPropagation();
      }
      this.criteria.showExcludeFromMerge = false;
      applyFilter();
    }

    selectAll(): void {
      if (this.isEditing) {
        const selectAll = this.selectAllBox;
        let items = this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage];
        _.forEach(items, (i: any) => {
          i.isSelected = selectAll;
          this.selectGroupItem(i);
        });
        this.refreshSelectAll();
      }
    }

    selectGroupItem(item: any): void {
      if (this.isEditing) {
        _.forEach(item.clientsToMerge, (i: any) => {
          i.queuedForMerge = item.isSelected;
          this.selectClientItemForMerge(i, item, false);
          if (!item.isSelected) {
            i.excludeFromMerge = item.isSelected;
            this.selectClientItemForIgnore(i, item, false);
          }
        } );
      }
    }

    selectClientItemForMerge(item: any, mergeGroup: any, refreshGroupSelection: boolean = true): void {
      // Deselect merge flag
      if (item.queuedForMerge)
        item.excludeFromMerge = false;
      // Update group selection
      if (refreshGroupSelection)
        mergeGroup.isSelected = _.some(mergeGroup.clientsToMerge, (item: any) => (this.isSelected(item) || this.isIgnored(item)));
    }

    selectClientItemForIgnore(item: any, mergeGroup: any, refreshGroupSelection: boolean = true): void {
      // Deselect ignore flag
      if (item.excludeFromMerge)
        item.queuedForMerge = false;
      // Update group selection
      if (refreshGroupSelection)
        mergeGroup.isSelected = _.some(mergeGroup.clientsToMerge, (item: any) => (this.isSelected(item) || this.isIgnored(item)));
    }

    goToClient(clientId, alertType: any) {
      var actionStateParam = Meevo.Model.MaintenanceFormState.Readonly;
      this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
        stateName: this.appSettings.ROUTE_NAMES.client,
        stateParams: {
          callback: null,
          callbackState: null,
          targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
          actionState: actionStateParam,
          id: clientId
        },
        clientAlertType: (_.isNumber(alertType) ? alertType : null)
      });
    }

    hasBirthday(n: any): boolean {
        return n && (n.birthMonth || n.birthDay || n.birthYear)
    }

    isViewingFromCentralOffice(): boolean {
        return this.identityService.inCentralOfficeMode()
    }

    formatBirthday(n: any): string {
        const monthFormatter = new Intl.DateTimeFormat("en-US", { month: "short" });
        const hasMonth = n.birthMonth != null;
        const hasDay = n.birthDay != null;
        const hasYear = n.birthYear != null;

        const monthStr = hasMonth ? monthFormatter.format(new Date(2000, n.birthMonth - 1, 1)).toUpperCase() : null;
        const dayStr = hasDay ? n.birthDay.toString().padStart(2, "0") : null;

        switch (true) {
            case hasMonth && hasDay && hasYear:
                return `${dayStr} ${monthStr} ${n.birthYear}`;
            case hasMonth && hasDay:
                return `${dayStr} ${monthStr}`;
            case hasMonth && hasYear:
                return `${monthStr} ${n.birthYear}`;
            case hasMonth:
                return `${monthStr}`;
            case hasDay && hasYear:
                return `${dayStr} ${n.birthYear}`;
            case hasDay:
                return `Day: ${dayStr}`;
            case hasYear:
                return `Year: ${n.birthYear}`;
        }
      }

    edit(): void {
      this.takeBackup();
      this.refreshSelectAll();
      this.mode = Meevo.Model.MaintenanceFormState.Editing;
      this.usageTrackingLog(Meevo.Model.NounEnum.IntelliMergePage, Model.VerbEnum.EditButtonClicked, null);
    }

      save(collapseAll: Function, criteria: any, applyFilter: Function): void {
          this.updateClientMerge()
              .then((needToRefresh: boolean) => {
                  if (needToRefresh) {
                      applyFilter();
                  }
              });
      }

      updateClientMerge(): ng.IPromise<boolean> {

          let groupItems = [];
          let mergePage = this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage];
          let showConfirmation = false;

          _.each(mergePage, (mergeGroup: any) => {
              let groupItem = {
                  mergeGroupId: mergeGroup.mergeGroupId,
                  clientsToMerge: [],
                  clientsToIgnore: []
              };
              if (mergeGroup.isSelected) {
                  // Get client items opted to Merge
                  let mergeList = _.where(mergeGroup.clientsToMerge, { queuedForMerge: true });
                  if (mergeList.length === 1) {
                      // Only one merge candidate was selected, which makes no sense... so clear them.
                      mergeGroup.isSelected = false;
                      _.each(mergeGroup.clientsToMerge, (item: any) => {
                          item.queuedForMerge = false;
                      });
                  }
                  else {
                      _.map(mergeList, (item: any) => {
                          groupItem.clientsToMerge.push(item.clientId);
                      });
                      showConfirmation = true;
                  }
                  // Get client items opted to Ignore
                  let ignoreList = _.where(mergeGroup.clientsToMerge, { excludeFromMerge: true });
                  if (ignoreList) {
                      _.map(ignoreList, (item: any) => {
                          groupItem.clientsToIgnore.push(item.clientId);
                      });
                  }
              }
              groupItems.push(groupItem);
          });

          if (showConfirmation) {
              return this.modalService.alert("MESSAGE_MERGE_CONFIRMATION", Meevo.Components.Modal.ModalTranslationModes.Translate, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                  .then(() => {
                      return this.updateWorker(groupItems);
                  });
          }
          else {
              return this.updateWorker(groupItems);
          }
      }

      updateWorker(groupItems: any[]): ng.IPromise<boolean> {
          this.usageTrackingLog(Meevo.Model.NounEnum.IntelliMergePage, Model.VerbEnum.SaveButtonClicked, groupItems);

          return this.dataService.add(this.appSettings.API_ENDPOINTS.clientMerge, { itemsToMerge: groupItems })
              .then((updateResponse: any) => {
                  // Check for merge conflict error code
                  if (updateResponse && updateResponse.errorCode === 'MERGE_CONFLICT') {
                      this.modalService.alert("MESSAGE_MERGE_CONFLICT", 
                          Meevo.Components.Modal.ModalTranslationModes.Translate, 
                          false);
                      return false;
                  }
                  else if (updateResponse && updateResponse.validationMessage) {
                      this.updateMergeValidationStatus(updateResponse.invalidDetails);
                      console.log(updateResponse.validationMessage);
                      // Emit error to framework dialog system
                      this.$rootScope.$emit(Meevo.Components.Common.Messages.SERVER_VALIDATION,
                          updateResponse.validationMessage,
                          Meevo.Model.NotificationModeType.Modal,
                          true);
                      return false;
                  }
                  else {
                      this.mode = Meevo.Model.MaintenanceFormState.Readonly;
                      return true;
                  }
              });
      }

    updateMergeValidationStatus(invalidDetails: any[]) {
      let mergePage = this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage];
      // Iterate invalid items
      _.forEach(invalidDetails, (i: any) => {
        // Find group
        const group = _.find(mergePage, (mg: any) => mg.mergeGroupId === i.mergeGroupId);
        if (group) {
          group.hasViolatedMemebershipMergeRule = i.hasActiveMembership;
          // Find item
          const ci = _.find(group.clientsToMerge, (c: any) => c.clientId === i.clientId);
          if (ci) {
            ci.hasViolatedMemebershipMergeRule = true;
            ci.queuedForMerge = false;
          }
        }
        // Update grroup selection
        group.isSelected = _.some(group.clientsToMerge, (c: any) => c.queuedForMerge || c.excludeFromMerge);
      });
    }

    cancel(): void {
      this.rollbackChanges();
      this.refreshSelectAll();
      this.mode = Meevo.Model.MaintenanceFormState.Readonly;
      this.usageTrackingLog(Meevo.Model.NounEnum.IntelliMergePage, Model.VerbEnum.CancelButtonClicked, null);
    }

    onPageLoaded(): void {
      this.refreshSelectAll();
      this.ensureBirthdayAccess();
    }

    isSelected(item: any): boolean {
        return item.queuedForMerge;
    }

    isIgnored(item: any): boolean {
        return item.excludeFromMerge;
    }

    get isEditing(): boolean {
        return this.mode == Meevo.Model.MaintenanceFormState.Editing;
    }

    get isReadonly(): boolean {
      return this.mode == Meevo.Model.MaintenanceFormState.Readonly;
    }

    private takeBackup() {
      this.backup = angular.copy(this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage]);
    }

    private rollbackChanges() {
      this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage] = angular.copy(this.backup);
      this.backup = null;
    }

    private refreshSelectAll(): void {
      let items = this.itemsArrayCtrl.pages[this.itemsArrayCtrl.currentPage];
      this.selectAllBox = _.every(items, (item: any) => item.isSelected);
    }

      private ensureBirthdayAccess(): void {
        this.securityService.checkSecurityKey(this.securityKeys.DATA_CLIENT_FIELDGROUP_SENSITIVEINFO + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then(d => {
            if (d == Model.SecurityAccessEnum.Grant) {
                this.canViewBirthdayInfo = true;
            }
        });
      }

    usageTrackingLog(nounEnum: Meevo.Model.NounEnum, verbEnum: Meevo.Model.VerbEnum, payload): void {
        if (nounEnum != null) {
            var trackingItem = new Meevo.Model.TrackingItem(nounEnum, verbEnum, payload, null);
            this.trackingService.saveTrackingInfo(trackingItem);
        }
    }

  }
}